import { Box, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

type SIZE = "sm" | "none";

const PADDING_CONFIG = {
  sm: "1.5rem",
  none: "0rem",
};

export type DrawerContentProps = {
  children?: ReactNode;
  sx?: SxProps<Theme>;
  pxSize?: SIZE;
};

export const DrawerContent = ({ children, sx, pxSize = "none" }: DrawerContentProps) => {
  return (
    <Box
      sx={{
        px: PADDING_CONFIG[pxSize],
        pt: "2.5rem",
        overflowY: "auto",
        height: "100%",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
